
export enum MessageTypeEnum {
    NORMAL = 'NRML',
    WARNING = 'WRNG',
    ALERT = 'ALRT'
}

export const MessageTypeDisplayValues = {
    NRML: 'Normal',
    WRNG: 'Warning',
    ALRT: 'Alert'
}